import { FC, useEffect, useState } from 'react';
import { Accordion, FontSize, useBreakpoint, NextgenDOMPurify } from '@nextgen-web-framework/all';
import type { FaqGroupsItem, FaqGroupsSubItems, FaqGroupsProps } from './types/propsTypes';
import styles from './FaqGroups.module.scss';

const FaqGroups: FC<FaqGroupsProps> = (data) => {
  const viewPortType = useBreakpoint();
  const [accordionFontSize, setAccordionFontSize] = useState(FontSize.LARGE);

  useEffect(() => {
    if (['xs', 'sm'].includes(viewPortType)) {
      setAccordionFontSize(FontSize.SMALL);
    } else {
      setAccordionFontSize(FontSize.LARGE);
    }
  }, [viewPortType]);

  return (
    <div className={styles['faq-group-container']} data-testid="faq-group-container-id">
      <h2 className={styles['faq-group-heading']}>{data.displayTitle}</h2>
      {data.faqsGroups?.map((faq: FaqGroupsItem, index: number) => (
        <Accordion
          key={`${faq.title}`}
          id={`faq-group-accordion${index}`}
          title={faq.title}
          fontSize={accordionFontSize}
        >
          <div>
            {faq.faqQuestionAnswer?.map((itemData: FaqGroupsSubItems) => (
              <div
                key={`${itemData.question}${itemData.answer}`}
                data-testid="faq-group-faqQuestionAnswer-container-id"
                className={styles['faq-group-question-answer-container']}
              >
                <div className={styles['faq-group-accordion-question']}>{itemData.question}</div>

                <div
                  className={styles['faq-group-accordion-answer']}
                  dangerouslySetInnerHTML={{
                    __html: data.sanitize
                      ? NextgenDOMPurify(itemData.answer, data.sanitizationConfig)
                      : itemData.answer,
                  }}
                ></div>
              </div>
            ))}
          </div>
        </Accordion>
      ))}
    </div>
  );
};

export default FaqGroups;
